// What the progress line says while a stage runs.
//
// The text has to advance or a wait of a minute or more reads as frozen. Keyed
// off elapsed time rather than server events, because the API reports a phase
// only when polled and the gaps between polls are longer than these steps.

const STEPS = {
  // The first student on a question waits for two model calls, because the
  // reference this essay is measured against has to be built before anything
  // can be measured. That is minutes, not seconds, and it happens once per
  // essay prompt. Saying "nearly there" from forty seconds into a five minute
  // wait reads as a lie by the third minute.
  diagnostic: [
    [0, 'Reading your essay…'],
    [8000, 'Working through the three tasks…'],
    [20000, 'Checking the reasoning trait by trait…'],
    [40000, 'Nearly there, this one is taking a little longer than usual.'],
    [75000, 'Still working. The first time anyone answers a question takes longer, '
          + 'because the standard your essay is compared against is being worked out.'],
    [180000, 'Still going. This is the slow part, and it only happens once for '
           + 'this question.'],
    [360000, 'Taking much longer than expected. You can leave this page, your '
           + 'work is saved, and the result will be here when you come back.'],
  ],
  enrichment: [
    [0, 'Looking at where the reasoning stalled…'],
    [8000, 'Working out the smallest change that would fix it…'],
    [25000, 'Nearly there.'],
  ],
  performance: [
    [0, 'Pulling the two sections together…'],
    [8000, 'Writing your development priority…'],
    [25000, 'Nearly there.'],
  ],
};

export function taraFeedbackProgressCopy(stage, elapsedMs = 0) {
  const steps = STEPS[stage] || STEPS.diagnostic;
  let text = steps[0][1];
  steps.forEach(([at, copy]) => {
    if (elapsedMs >= at) text = copy;
  });
  return text;
}
